/** Cloudinary folder used for space images across MillionSpaces environments. */
const SPACE_IMAGE_FOLDER = 'ms-singapore';

/**
 * Resolves an image URL or public ID to a final usable URL.
 * Handles both legacy Cloudinary public IDs and new S3/CloudFront absolute URLs.
 */
export const resolveImageUrl = (value, s3CloudfrontUrl) => {
  if (!value || typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  // If it's already an absolute URL (e.g. S3/CloudFront), return it directly
  if (/^https?:\/\//i.test(trimmed)) {
    // If it's a Cloudinary URL, we can still use it directly, but ideally
    // we extract the public ID. For now, let's just return the full URL
    // if it's not a Cloudinary domain to support S3 properly.
    if (!trimmed.includes('res.cloudinary.com')) {
        return trimmed;
    }
  }

  // Legacy Cloudinary extraction logic
  try {
    const urlObj = /^https?:\/\//i.test(trimmed) ? new URL(trimmed) : null;
    const pathToParse = urlObj ? urlObj.pathname : trimmed;
    
    const folderMarker = `/${SPACE_IMAGE_FOLDER}/`;
    const folderIdx = pathToParse.indexOf(folderMarker);
    if (folderIdx !== -1) {
      return pathToParse.slice(folderIdx + 1).split('?')[0] || null;
    }

    const parts = pathToParse.split('/').filter(Boolean);
    const folderPartIdx = parts.indexOf(SPACE_IMAGE_FOLDER);
    if (folderPartIdx !== -1) {
      return parts.slice(folderPartIdx).join('/').split('?')[0] || null;
    }
  } catch {
    return trimmed; // Fallback to raw value if parsing fails
  }

  // If we couldn't parse it as Cloudinary, but it's just a raw public ID
  return trimmed.replace(/^\/+/, '');
};

export const extractCloudinaryPublicId = resolveImageUrl; // Alias for backward compatibility

/**
 * Picks the first resolvable public id from common agent/search image fields.
 */
export const resolveSpaceImagePublicId = (space = {}) => {
  const candidates = [
    space.image,
    space.primaryImageUrl,
    ...(Array.isArray(space.imageUrls) ? space.imageUrls : []),
  ];

  for (const candidate of candidates) {
    const publicId = extractCloudinaryPublicId(candidate);
    if (publicId) return publicId;
  }

  return null;
};
